import React from 'react';
import { Country } from '../../types/Country';
import { useTranslation } from 'react-i18next';
import { STATE_INACTIVE } from '../../utils/variables';

type Props = {
  state: Country[];
}

const FilterResultCount: React.FunctionComponent<Props> = (props: Props) => {
  const { state } = props;
  const { t } = useTranslation();

  const resultCount = () => {
    const matchingCountries = state.filter(country => {
      return country.state !== STATE_INACTIVE;
    });
    return matchingCountries.length;
  }

  const result = () => {
    const count = resultCount();
    if (count > 1) {
      return <h4>{t('filters:results', {count: resultCount()})}</h4>;
    }
    else if (count === 1) {
      return <h4>{t('filters:result', {count: resultCount()})}</h4>;
    }
    else {
      return <h4>{t('filters:noResults', {count: resultCount()})}</h4>;
    }
  }

  return(
    <div className='filter-result-count'>
      {result()}
    </div>
  )
}

export default FilterResultCount;
